import { getEducationStatusMeta } from 'utils/education';
import { BaseCellOptionProps } from '../types/Cell';
import { DefaultCell } from './DefaultCell';

export const EducationCell = (props: BaseCellOptionProps): React.ReactElement => {
  const { label } = props;

  const eduPillMeta = getEducationStatusMeta(label);

  return (
    <DefaultCell
      px={10}
      py={5}
      borderRadius="l"
      bgColor={eduPillMeta.bgColor}
      label={eduPillMeta.labelValue}
      labelColor={eduPillMeta.labelColor}
    />
  );
};
